/**
 * Mod Icons Bundle — локальный набор SVG иконок для модов
 * Без внешних зависимостей (Iconify, CDN и т.д.)
 *
 * Использование:
 *   ModIcons.get('fire')        → SVG строка
 *   ModIcons.render('fire', 24) → <svg> element
 *   ModIcons.all()              → [{name, label, svg}]
 */
window.ModIcons = (function() {
    'use strict';

    // viewBox="0 0 24 24", stroke-based paths
    const icons = {
        // Популярные
        fire: { label: 'Огонь', path: 'M12 23C7.03 23 3 18.97 3 14c0-3.13 1.53-6.06 4.09-7.83L9 5l1.06 2.11C11.25 5.4 12 3 12 3s4 4.5 4 4.5 1.5-1.5 2-2c1.56 2.34 3 5.3 3 8.5 0 4.97-4.03 9-9 9zm0-2c3.87 0 7-3.13 7-7 0-2.35-.98-4.5-2.17-6.09-.35.52-.89 1.18-1.54 1.58C14.24 10.27 13 9 12.5 7.5c-.5 1.5-1.74 2.77-2.79 3.99-.65-.4-1.19-1.06-1.54-1.58C7 11.5 5 13.65 5 16c0 3.87 3.13 7 7 7z' },
        star: { label: 'Звезда', path: 'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z' },
        lightning: { label: 'Молния', path: 'M13 2L3 14h9l-1 10 10-12h-9l1-10z' },
        heart: { label: 'Сердце', path: 'M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z' },
        sparkle: { label: 'Блеск', path: 'M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8L12 2z' },

        // Стиль / мода
        camera: { label: 'Камера', path: 'M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2v11zM12 17a5 5 0 100-10 5 5 0 000 10z' },
        palette: { label: 'Палитра', path: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10a2.5 2.5 0 002.5-2.5c0-.61-.23-1.2-.63-1.63-.37-.4-.37-.92-.01-1.34.5-.56 1.64-.53 1.64-.53 3.04 0 5.5-2.46 5.5-5.5C21 6.23 16.97 2 12 2zM6.5 13a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z' },
        brush: { label: 'Кисть', path: 'M20.71 4.04c-.78-.78-2.05-.78-2.83 0l-9.17 9.17c-.79-.24-1.63-.36-2.46-.36-2.76 0-5.25 1.5-5.25 4.5 0 2.62 2.1 4.65 4.75 4.65 1.5 0 2.85-.58 3.79-1.54.96-.96 1.46-2.3 1.46-3.71 0-.83-.12-1.67-.36-2.46l9.17-9.17c.78-.78.78-2.05 0-2.83l-.1-.25z' },
        wand: { label: 'Палочка', path: 'M15 4l3 3-12 12-3-3L15 4zm-1.41 1.41L5.17 13.83l1 1 8.42-8.42-1-1zM20 2l2 2-1.5 1.5-2-2L20 2zM3 19l2 2-1 1-2.5.5.5-2.5 1-1z' },
        crown: { label: 'Корона', path: 'M2 20h20v2H2v-2zm1-7l4.5 2L12 4l4.5 11L21 13l-2 7H5l-2-7z' },
        gem: { label: 'Алмаз', path: 'M6 3h12l4 7-10 11L2 10l4-7zm2.94 1L6.26 9h11.48l-2.68-5H8.94zM12 18.5L19.37 10H4.63L12 18.5z' },

        // Действия / эмоции
        rocket: { label: 'Ракета', path: 'M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09zM12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11.95A22 22 0 0112 15z' },
        magic: { label: 'Магия', path: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2V7zm0 8h2v2h-2v-2z' },
        ghost: { label: 'Призрак', path: 'M12 2a9 9 0 00-9 9v11l3-3 3 3 3-3 3 3 3-3 3 3V11a9 9 0 00-9-9zM9 13a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4z' },
        flame: { label: 'Пламя', path: 'M17.66 11.2C17.43 10.9 17.15 10.64 16.89 10.38C16.22 9.78 15.46 9.35 14.82 8.72C13.33 7.26 13 4.85 13.95 3C13 3.23 12.17 3.75 11.46 4.32C8.87 6.4 7.85 10.07 9.07 13.22C9.11 13.32 9.15 13.42 9.15 13.55C9.15 13.77 9 13.97 8.8 14.05C8.57 14.15 8.33 14.09 8.14 13.93C8.08 13.88 8.04 13.83 8 13.76C6.87 12.33 6.69 10.28 7.45 8.64C5.78 10 4.87 12.3 5 14.47C5.06 14.97 5.12 15.47 5.29 15.97C5.43 16.57 5.7 17.17 6 17.7C7.08 19.43 8.95 20.67 10.96 20.92C13.1 21.19 15.39 20.8 16.96 19.32C18.73 17.65 19.38 15.01 18.43 12.86L18.3 12.56C18.1 12.1 17.83 11.65 17.66 11.2z' },
        music: { label: 'Музыка', path: 'M12 3v10.55A4 4 0 1014 17V7h4V3h-6z' },
        gamepad: { label: 'Геймпад', path: 'M6 11h4v4h2v-4h4v-2h-4V5h-2v4H6v2zm15 0a9 9 0 01-9 9 9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9z' },
        sun: { label: 'Солнце', path: 'M12 7a5 5 0 100 10 5 5 0 000-10zm0-5v2m0 16v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M2 12h2m16 0h2M6.34 17.66l-1.42 1.42M19.78 4.22l-1.42 1.42' },
        moon: { label: 'Луна', path: 'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z' },
        leaf: { label: 'Лист', path: 'M17 8C8 10 5.9 16.17 3.82 21.34l1.89.66.95-2.3c.48.17.98.3 1.34.3C19 20 22 3 22 3c-1 2-8 2.25-13 3.25S2 11.5 2 13.5s1.75 3.75 1.75 3.75' },
        eye: { label: 'Глаз', path: 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12zm11 5a5 5 0 100-10 5 5 0 000 10z' },
        shield: { label: 'Щит', path: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' },
        target: { label: 'Мишень', path: 'M12 22a10 10 0 100-20 10 10 0 000 20zm0-4a6 6 0 100-12 6 6 0 000 12zm0-4a2 2 0 100-4 2 2 0 000 4z' },
        gift: { label: 'Подарок', path: 'M20 12v10H4V12m16 0H4m16 0h2V8h-8.5M4 12H2V8h8.5M12 22V8m0 0H8.21a3 3 0 11.79-4h3m0 4h3a3 3 0 10-.79-4H12' },
        coffee: { label: 'Кофе', path: 'M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zm2-6h12m-8 2v2m4-2v2' },
        plane: { label: 'Самолёт', path: 'M21 16v-2l-8-5V3.5a1.5 1.5 0 00-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' },
        puzzle: { label: 'Пазл', path: 'M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 01-.837.276c-.47-.07-.802-.48-.968-.925-.186-.498-.545-.932-1.072-1.072-.527-.14-1.074.014-1.476.35-.903.753-.833 2.14.188 2.806.378.247.616.605.616 1.052 0 .318-.118.636-.352.879l-1.586 1.586A2.41 2.41 0 0112.5 21a2.41 2.41 0 01-1.698-.704l-1.568-1.568a1.198 1.198 0 01-.289-.877c.07-.471.48-.803.925-.969.498-.186.932-.545 1.072-1.072.14-.527-.014-1.074-.35-1.476-.753-.903-2.14-.833-2.806.188-.247.378-.605.616-1.052.616-.318 0-.636-.118-.879-.352L4.27 13.198A2.41 2.41 0 013.566 11.5a2.41 2.41 0 01.704-1.698l1.568-1.568c.23-.23.556-.338.877-.289.471.07.803.48.969.925.186.498.545.932 1.072 1.072.527.14 1.074-.014 1.476-.35.903-.753.833-2.14-.188-2.806-.378-.247-.616-.605-.616-1.052 0-.318.118-.636.352-.879L11.386 3.27A2.41 2.41 0 0113.084 2.566a2.41 2.41 0 011.698.704l1.568 1.568' },

        // Инструменты каталога (Влад 15.09.2026: «подбери другие иконки»).
        // Линейные, в одном языке с иконками таббара: stroke:true —
        // см. getSvg. Заливкой такие контуры превращаются в кляксы.
        sticker: {
            label: 'Стикер',
            stroke: true,
            path: [
                'M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v6L12.5 20h-6A2.5 2.5 0 014 17.5v-11z',
                'M20 12.5h-5a2.5 2.5 0 00-2.5 2.5v5',
            ],
        },
        scissors: {
            label: 'Вырезать',
            stroke: true,
            path: [
                'M7.4 15.4L17 5',
                'M16.6 15.4L7 5',
                'M8 17.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
                'M21 17.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
            ],
        },
        restore: {
            label: 'Восстановить',
            stroke: true,
            path: [
                'M3.5 12a8.5 8.5 0 108.5-8.5A8.5 8.5 0 005.8 6',
                'M3 3.2v4h4',
                'M12 7.8v4.4l3 1.8',
            ],
        },
        upscale: {
            label: 'Качество',
            stroke: true,
            path: [
                'M4 9V6a2 2 0 012-2h3',
                'M15 4h3a2 2 0 012 2v3',
                'M20 15v3a2 2 0 01-2 2h-3',
                'M9 20H6a2 2 0 01-2-2v-3',
                'M14.5 9.5l-5 5',
                'M14.5 13.2V9.5h-3.7',
            ],
        },
    };

    /**
     * Получить SVG строку по имени
     */
    function getSvg(name, size = 24) {
        const icon = icons[name];
        if (!icon) return '';
        // path — строка или массив контуров (линейной иконке редко
        // хватает одного). stroke:true рисует контуром, как иконки
        // таббара; по умолчанию — заливка, как у старого набора.
        const paths = (Array.isArray(icon.path) ? icon.path : [icon.path])
            .map((d) => `<path d="${d}"/>`)
            .join('');
        const paint = icon.stroke
            ? 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"'
            : 'fill="currentColor"';
        return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" ${paint} xmlns="http://www.w3.org/2000/svg">${paths}</svg>`;
    }

    /**
     * Создать SVG элемент
     */
    function render(name, size = 24) {
        const wrapper = document.createElement('span');
        wrapper.innerHTML = getSvg(name, size);
        return wrapper.firstChild || wrapper;
    }

    /**
     * Получить все иконки (для picker)
     */
    function all() {
        return Object.entries(icons).map(([name, data]) => ({
            name,
            label: data.label,
            svg: getSvg(name, 24)
        }));
    }

    /**
     * Проверить существование иконки
     */
    function has(name) {
        return name in icons;
    }

    return { getSvg, render, all, has };
})();
